module.exports = __webpack_public_path__ + "media/mooma-header.c5253efd.mp4";